import React, {Component} from 'react';
import {connect} from "react-redux";
import FJPreviewVideo from "../view/FJPreviewVideo";
import FJCanvasStore from "../../../store/FJCanvasStore";
import FJExportPreviewAction from "../../../redux/action/FJExportPreview.action";
import FJViewConstant from "../../../constant/FJViewConstant";

class FJPreviewContainer extends Component {

  /**
   * @description 更新核心库画布尺寸
   * @param size
   */
  updateCanvasSize(size) {
    let {UPDATE_CANVAS_SIZE} = FJCanvasStore.command;
    FJCanvasStore.execute(UPDATE_CANVAS_SIZE, size);
  }

  /**
   * @description 初始化画布
   * @param canvas
   * @param eventView
   */
  initCanvas(canvas, eventView) {
    FJCanvasStore.executeSync(FJCanvasStore.command.INIT_CANVAS, canvas, eventView);
  }

  reRender = () => {
    FJCanvasStore.executeSync(FJCanvasStore.command.RERENDER);
  };

  render() {
    const {ratioType, previewRatioType, height, isResourceExpand} = this.props;
    const {disableIntro} = this.props;
    return <FJPreviewVideo initCanvas={this.initCanvas}
                           reRender={this.reRender}
                           disableIntro={disableIntro}
                           updateCanvasSize={this.updateCanvasSize}
                           ratioType={ratioType}
                           previewRatioType={previewRatioType}
                           isResourceExpand={isResourceExpand}
                           hasBorder={ratioType !== FJViewConstant.RATIO_LANDSCAPE}
                           height={height}/>
  }
}

const mapStateToProps = function (state) {
  return {
    ratioType: state.more.ratioType,
    previewRatioType: state.more.previewRatioType,
    isResourceExpand: state.resource.isResourceExpand,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    disableIntro: function () {
      dispatch(FJExportPreviewAction.disableIntroAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJPreviewContainer);

